export var FRAMEWORK = {
  None: '0',
  ReactNative: '1'
};
export var AUTH_CATEGORY = 'auth';